// Updated input filtering functions to handle specific field requirements
export const filterInputByType = (
  value: string,
  type: string,
  columnKey?: string
): string => {
  // Special handling for specific fields that should allow numbers only
  const numericFields = [
    "Pincode",
    "Emergency Contact",
    "Mobile Number",
    "pincode",
    "emergency_contact",
    "mobile_number",
  ];
  const isNumericField = numericFields.includes(columnKey || "");

  // Text-only fields (e.g. human names) where numbers and symbols are disallowed
  const textOnlyFields = [
    "First Name",
    "Last Name",
    "first_name",
    "last_name",
  ];
  const isTextOnlyField = textOnlyFields.includes(columnKey || "");

  switch (type) {
    case "number":
      // Allow only numbers, decimal point, and minus sign
      return value.replace(/[^0-9.-]/g, "");

    case "email":
      // Allow alphanumeric, @, ., -, _, +
      return value.replace(/[^a-zA-Z0-9@._+-]/g, "");

    case "phone":
      // Allow only numbers, +, -, (, ), and spaces
      return value.replace(/[^0-9+\-() ]/g, "");

    case "url":
      // Allow alphanumeric, common URL characters
      return value.replace(/[^a-zA-Z0-9:/.?=&_-]/g, "");

    case "text":
    default:
      // Special handling for numeric fields (Pincode, Emergency Contact, Mobile Number)
      if (isNumericField) {
        return value.replace(/[^0-9]/g, ""); // Allow only numbers
      }
      // Text-only fields (First Name, Last Name) - remove numbers and special characters
      else if (isTextOnlyField) {
        return value.replace(/[<>{}^&*%$#@!)(+_?":;0-9]/g, "");
      }
      // General text / alphanumeric fields (Barcode, HSN Code, Product Name, SKU Code, Description, Address, etc.)
      else {
        return value.replace(/[<>{}^&*%$#@!)(+?":;]/g, "");
      }
  }
};

// Updated handleKeyPress function
export const handleKeyDown = (
  event: React.KeyboardEvent,
  type: string,
  columnKey?: string
) => {
  const char = event.key;

  // Allow control keys (Backspace, Delete, Tab, Enter, Arrow keys, etc.)
  const controlKeys = [
    "Backspace",
    "Delete",
    "Tab",
    "Enter",
    "Escape",
    "ArrowLeft",
    "ArrowRight",
    "ArrowUp",
    "ArrowDown",
    "Home",
    "End",
    "PageUp",
    "PageDown",
    "Insert",
    "F1",
    "F2",
    "F3",
    "F4",
    "F5",
    "F6",
    "F7",
    "F8",
    "F9",
    "F10",
    "F11",
    "F12",
  ];

  // Allow Ctrl/Cmd combinations (Copy, Paste, Cut, Select All, etc.)
  if (event.ctrlKey || event.metaKey) {
    return;
  }

  // Allow control keys
  if (controlKeys.includes(char)) {
    return;
  }

  // Special handling for specific fields that should allow numbers only
  const numericFields = [
    "Pincode",
    "Emergency Contact",
    "Mobile Number",
    "pincode",
    "emergency_contact",
    "mobile_number",
  ];
  const isNumericField = numericFields.includes(columnKey || "");

  // Text-only fields (e.g. human names) where numbers and symbols are disallowed
  const textOnlyFields = [
    "First Name",
    "Last Name",
    "first_name",
    "last_name",
  ];
  const isTextOnlyField = textOnlyFields.includes(columnKey || "");

  switch (type) {
    case "number":
      if (!/[0-9.-]/.test(char)) {
        event.preventDefault();
      }
      break;

    case "email":
      if (!/[a-zA-Z0-9@._+-]/.test(char)) {
        event.preventDefault();
      }
      break;

    case "phone":
      if (!/[0-9+\-() ]/.test(char)) {
        event.preventDefault();
      }
      break;

    case "url":
      if (!/[a-zA-Z0-9:/.?=&_-]/.test(char)) {
        event.preventDefault();
      }
      break;

    case "text":
      // Special handling for numeric fields (Pincode, Emergency Contact, Mobile Number)
      if (isNumericField) {
        if (!/[0-9]/.test(char)) {
          event.preventDefault();
        }
      }
      // Text-only fields (First Name, Last Name) - prevent numbers and special characters
      else if (isTextOnlyField) {
        if (/[<>{}^&*%$#@!)(+_?":;0-9]/.test(char)) {
          event.preventDefault();
        }
      }
      // General text / alphanumeric fields (Barcode, HSN Code, Product Name, SKU Code, etc.)
      else {
        if (/[<>{}^&*%$#@!)(+?":;]/.test(char)) {
          event.preventDefault();
        }
      }
      break;
  }
};
